import { createSelector } from '@ngrx/store';
import { getSharedFeatureState, SharedState } from '../reducers';

const getActionItemState = createSelector(getSharedFeatureState, (state: SharedState) => state.actionItemState);

export const getActionItemNotificationCount = createSelector(getActionItemState, (state) => state.actionItemNotificationCount);
export const getActionItemMenuCounts = createSelector(getActionItemState, (state) => state.actionItemMenuCounts);
